import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import BoletimLayer from "../components/BoletimLayer";
import { useTranslation } from "../i18n/I18nContext";

const BoletimPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("boletim.breadcrumb")} />
      <BoletimLayer />
    </MasterLayout>
  );
};

export default BoletimPage;
